const flags = {
  CA: '🇨🇦',
  US: '🇺🇸',
}

export default flags
